/**
 * @fileoverview Validation utilities for form inputs
 */
/**
 * Validates certificate form data
 */
export const validateCertificateForm = (data) => {
    const errors = {};
    if (!data.beneficiaryName || data.beneficiaryName.trim().length === 0) {
        errors.beneficiaryName = 'El nombre del beneficiario es requerido';
    }
    if (!data.idOrLicense || data.idOrLicense.trim().length === 0) {
        errors.idOrLicense = 'El ID o licencia es requerido';
    }
    if (!data.certificateType) {
        errors.certificateType = 'El tipo de certificación es requerido';
    }
    if (!data.issueDate) {
        errors.issueDate = 'La fecha de emisión es requerida';
    }
    return {
        isValid: Object.keys(errors).length === 0,
        errors,
    };
};
